module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', {
    attrs: {
      "id": "recipeSearch"
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.q),
      expression: "model.q"
    }],
    staticClass: "search-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by; title, ingredient or category"
    },
    domProps: {
      "value": (_vm.model.q)
    },
    on: {
      "keydown": _vm.handleSearchKeydown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "q", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Cooking time")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underTenMin'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnder10Min()
      }
    }
  }, [_vm._v("\n            0 - 10 min\n          ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underThirtyMinOverTen'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnderThirtyMinOverTen()
      }
    }
  }, [_vm._v("\n            Under 30 min\n          ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'underHourOver30'
    },
    staticStyle: {
      "margin-bottom": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setUnderHourOver30()
      }
    }
  }, [_vm._v("\n            30 min - 1 hour\n          ")]), _vm._v(" "), _c('mu-chip', {
    staticClass: "cooking-time-chip",
    class: {
      'active': _vm.timeFilter === 'overHour'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setOverHour()
      }
    }
  }, [_vm._v("\n            Over 1 hour\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.model.totaltime.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.totaltime),
      callback: function($$v) {
        _vm.$set(_vm.model, "totaltime", $$v)
      },
      expression: "model.totaltime"
    }
  }, 'vue-slider', _vm.timeSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom"
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "left"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.model.totaltime[0]) + " min(s)\n        ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50",
      "align": "right"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.model.totaltime[1]) + " min(s)\n        ")])], 1), _vm._v(" "), _c('h2', [_vm._v("Nutrition")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Carbohydrate "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.carbs[0] + ' - ' + _vm.model.carbs[1]) + "g")])]), _vm._v(" "), (_vm.model.carbs.length > 0) ? _c('vue-slider', _vm._b({
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.carbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "carbs", $$v)
      },
      expression: "model.carbs"
    }
  }, 'vue-slider', _vm.carbSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Fat "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.fat[0] + ' - ' + _vm.model.fat[1]) + "g")])]), _vm._v(" "), (_vm.model.fat.length > 0) ? _c('vue-slider', _vm._b({
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.fat),
      callback: function($$v) {
        _vm.$set(_vm.model, "fat", $$v)
      },
      expression: "model.fat"
    }
  }, 'vue-slider', _vm.fatSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Calories "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.calories[0] + ' - ' + _vm.model.calories[1]) + "kcal")])]), _vm._v(" "), (_vm.model.calories.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "start-animation": false
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.calories),
      callback: function($$v) {
        _vm.$set(_vm.model, "calories", $$v)
      },
      expression: "model.calories"
    }
  }, 'vue-slider', _vm.calorieSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Protein "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.protein[0] + ' - ' + _vm.model.protein[1]) + "g")])]), _vm._v(" "), (_vm.model.protein.length > 0) ? _c('vue-slider', _vm._b({
    attrs: {
      "start-animation": false
    },
    on: {
      "drag-end": _vm.checkChanged
    },
    model: {
      value: (_vm.model.protein),
      callback: function($$v) {
        _vm.$set(_vm.model, "protein", $$v)
      },
      expression: "model.protein"
    }
  }, 'vue-slider', _vm.proteinSlider, false)) : _vm._e()], 1), _vm._v(" "), _c('h2', [_vm._v("Dietary types")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.dietaryTypes), function(item, dietaryTypeI) {
    return _c('mu-col', {
      key: 'dietaryType-' + dietaryTypeI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.categories), function(item, catI) {
    return _c('mu-col', {
      key: 'category-' + catI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n          ")])], 1)
  }), 1), _vm._v(" "), (!_vm.additionalOptions && _vm.fullWidth) ? _c('div', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "More filters",
      "full-width": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.additionalOptions = !_vm.additionalOptions
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.additionalOptions && _vm.fullWidth) ? _c('div', {
    staticStyle: {
      "margin-top": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "Hide filters",
      "full-width": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.additionalOptions = !_vm.additionalOptions
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.additionalOptions),
      expression: "additionalOptions"
    }]
  }, [_c('h2', [_vm._v("Allergies")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.suitabilities), function(item, suitabilityI) {
    return _c('mu-col', {
      key: 'suitability-' + suitabilityI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Cuisines")]), _vm._v(" "), _c('mu-row', _vm._l((_vm.model.cuisines), function(item, cuisineI) {
    return _c('mu-col', {
      key: 'cuisine-' + cuisineI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1), _vm._v(" "), _c('h2', [_vm._v("Occasions")]), _vm._v(" "), _c('mu-row', {
    staticClass: "bottom"
  }, _vm._l((_vm.model.occasions), function(item, occasionI) {
    return _c('mu-col', {
      key: 'occasion-' + occasionI,
      attrs: {
        "width": "50",
        "tablet": "100",
        "desktop": _vm.fullWidth === true ? '50' : '25'
      }
    }, [_c('mu-checkbox', {
      attrs: {
        "label": item.label
      },
      on: {
        "change": _vm.checkChanged
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.label) + "\n            ")])], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isSearching,
      "secondary": "",
      "label": _vm.isSearching === true ? _vm.$t('message.loadingText') : _vm.$t('message.searchText'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitSearch.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c41f85a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Search.vue
// module id = 3679
// module chunks = 1